module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.41116in",
      "height": "2.54in"
    },
    attrs: {
      "alt": "",
      "src": "media/file0.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("C:\\Users\\ViralWebbs\\Pictures\\2.jpg")])]), _vm._v(" "), _c('p', [_vm._v("Michael Eicherly was born in Garden Grove California, on January 10"), _c('sup', [_vm._v("th")]), _vm._v(", 1969. He currently lives in the Mission District of San Gabriel, California. Together, he and his wife have three children. His passions are horror films, music, books, family and Lucky Baldwin pubs.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-256644c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0